const Receipt = (props) => {
    return <svg width="24" height="24" role={props.role} className={props.className} onClick={props?.onClick} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="receipt-check">
            <path id="Icon" d="M9 10.5L11 12.5L15.5 8M20 21V7.8C20 6.11984 20 5.27976 19.673 4.63803C19.3854 4.07354 18.9265 3.6146 18.362 3.32698C17.7202 3 16.8802 3 15.2 3H8.8C7.11984 3 6.27976 3 5.63803 3.32698C5.07354 3.6146 4.6146 4.07354 4.32698 4.63803C4 5.27976 4 6.11984 4 7.8V21L6.75 19L9.25 21L12 19L14.75 21L17.25 19L20 21Z" stroke={props?.color || "#98A2B3"} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
        </g>
    </svg>
}

export default Receipt;